import { useState, useEffect, useCallback } from "react";
import { enqueueSnackbar } from "notistack";
import { getTeacherSubjectMapping } from "../services/TeacherSubjectMappingService";

export const useTeacherPrograms = () => {
  const [programData, setProgramData] = useState([]);
  const [isTeacherProgramLoading, setIsTeacherProgramLoading] = useState(false);

  const fetchTeacherPrograms = useCallback(async () => {
    setIsTeacherProgramLoading(true);
    
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const user_id = user?.id;

      if (!user_id) {
        enqueueSnackbar("Invalid user session", { variant: "error" });
        return;
      }

      const response = await getTeacherSubjectMapping(user_id);

      if (response.status === 200) {
        const list = response.data.data || {};

        let programs = list.programs || [];

        // merge class in-charge programs
        if (Array.isArray(list.class_in_charge) && list.class_in_charge.length) {
          const classInChargePrograms = list.class_in_charge.map((item) => ({
            id: item.id,
            name: item.name,
            subjects: item.subjects || [],
          }));

          programs = [...programs, ...classInChargePrograms];
        }
        setProgramData(programs);
      }
    } catch (error) {
      console.error("Teacher program fetch failed:", error);
      enqueueSnackbar("Failed to load programs", { variant: "error" });
    } finally {
      setIsTeacherProgramLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTeacherPrograms();
  }, [fetchTeacherPrograms]);

  return {
    programData,
    isTeacherProgramLoading,
    refetchTeacherPrograms: fetchTeacherPrograms,
  };
};
